import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { getAttribution } from "@/lib/tracking";

export const useLeadSubmit = (type) => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");

  const submit = async (values, photos = []) => {
    setError("");
    setProgress(0);
    const payload = { ...values, type, ...getAttribution() };
    const body = new FormData();
    body.append("payload", JSON.stringify(payload));
    photos.forEach((file) => body.append("photos", file, file.name));
    try {
      const { data } = await api.post("/leads", body, {
        onUploadProgress: (e) => e.total && setProgress(Math.round((e.loaded * 100) / e.total)),
      });
      navigate("/danke", { state: { ref: data.ref, type: data.type } });
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return { submit, progress, error };
};
